import React, { Component } from 'react';

import { 
FROM_DATE, 
TO_DATE,
EXCEL_FORMAT_TYPE,
DEFAULT_TIME,
VENDOR_DATA_DEFAULT_FILE_NAME,
INVALID_DATE_RANGE_MSG,
INTERNAL_SERVER_ERROR_MSG,
BAD_REQUEST_ERROR_MSG,
EMPTY_RESPONSE_MSG
} from './constant.js';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './style.scss';
import fileSaver from 'file-saver';
import {fetchVendorData} from './action';
import withAuth from '../../components/Services/WithAuth';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input,Row, CardFooter } from 'reactstrap'
class VendorTrackerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: null,
            fromDate: null,
            loading:false,
            isfetchVendorDataSuccess:false,
            vendorDataFileName:null
        }
        
    }
    updateBooleanStates=(load,dataSuccess)=>
    {
        this.setState(
            {
                loading:load,
                isfetchVendorDataSuccess:dataSuccess,
            }
        )
    }

    onChangeDate = (date, type) => {
        this.updateBooleanStates(false,false);
        let selectedDate=date.format().split('T')[0]+'T'+DEFAULT_TIME;
        switch (type) {
            case FROM_DATE:
                this.setState({
                    fromDate: selectedDate,
                    
                })
                break;
            case TO_DATE:
                this.setState({
                    toDate: selectedDate
                })
                break;
            default:
        }
    }

    handleFetchVendorData=(e)=>
    {
        e.preventDefault();
        if(this.state.fromDate && this.state.toDate && this.state.fromDate>this.state.toDate)
        {
           this.displayErrorMessage(INVALID_DATE_RANGE_MSG);
           this.setState({
            fromDate:null,
            toDate:null
           }); 
           
        }
        else{
            this.setState({loading:true})
        this.props.fetchVendorData({fromDate:this.state.fromDate,toDate:this.state.toDate});
        }
    }
    

    componentDidUpdate(prevProps) 
    {
        const { vendorDataFile,vendorDataError } = this.props;
        if ( vendorDataFile && vendorDataFile !== prevProps.vendorDataFile) 
        {
            this.updateBooleanStates(false,true);
            var curFileName=VENDOR_DATA_DEFAULT_FILE_NAME+'_'+this.state.fromDate.split('T')[0]+'__'+this.state.toDate.split('T')[0]+'.xlsx';
            this.setState({fromDate:null,toDate:null,vendorDataFileName:curFileName})
        }
        else if (vendorDataError && vendorDataError !== prevProps.vendorDataError) 
        {
            this.updateBooleanStates(false,false);
            let message=''
            if(vendorDataError.status==404)
            {
                message=EMPTY_RESPONSE_MSG+this.state.fromDate+'__'+this.state.toDate;
            }
            else if(vendorDataError.status>=400)
            {
                message=BAD_REQUEST_ERROR_MSG;
            }
            else //for 500
            {
                message=INTERNAL_SERVER_ERROR_MSG;
            }
            this.displayErrorMessage(message);
        }
        
    }

    downloadVendorData(){
        if(this.props.vendorDataFile)
        {
            var blob = new Blob([this.props.vendorDataFile], { type:EXCEL_FORMAT_TYPE });
            fileSaver.saveAs(blob, this.state.vendorDataFileName);
        }
    }

    displayErrorMessage = (message) => {
        toast.error(
            <div>
                <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
            </div>
        )
    }

    render() {
        return (
            
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Vendor Tracker</h4>
                </div>
                <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup className="general-form-style" row>
                                <Label sm={10}> Select date range to extract vendor data</Label>
                            </FormGroup>
                            <FormGroup className="general-form-style" row>
                                <Label sm={3}>From Date:</Label>
                                <Row>
                                    <Col sm='30'>
                                        <DatePicker className="form-control"  name="From Date" onChange={(date) => this.onChangeDate(moment(date), FROM_DATE)} dateFormat="YYYY-MM-dd" selected={(this.state.fromDate) ? moment(this.state.fromDate).toDate() : null} placeholderText='FromDate:YYYY-MM-DD' popperPlacement='bottom' popperModifiers={{
                                            flip: {behavior: ["bottom"] },
                                            preventOverflow: {enabled: false},
                                            hide: {enabled: false}}}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup className="to-date-input" row>
                                <Label sm={3}>To Date:</Label>
                                <Row>
                                    <Col sm='30'>
                                        <DatePicker className="form-control" onChange={(date) => this.onChangeDate(moment(date), TO_DATE)} dateFormat="YYYY-MM-dd" selected={(this.state.toDate) ? moment.utc(this.state.toDate).toDate() : null} placeholderText='ToDate:YYYY-MM-DD' popperPlacement='bottom' popperModifiers={{
                                            flip: {behavior: ["bottom"] },
                                            preventOverflow: {enabled: false},
                                            hide: {enabled: false}}}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup className="generate-vendor-btn"  row>
                                <Row >
                                    <Col  xs="30" >
                                        {!this.state.loading?
                                        <Button color="primary" className="btn" onClick={(e) =>this.handleFetchVendorData(e)} disabled={!this.state.fromDate || !this.state.toDate}>Generate Vendor Data</Button>
                                        :null}
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup className="general-form-style" row>
                                <Row>
                                    <Col xs="30">
                                        {this.state.isfetchVendorDataSuccess?
                                        <div >
                                        <span aria-hidden="true">Vendor Data fetched Successfully...</span>
                                        <Button color="primary" className="btn" onClick={(e) =>this.downloadVendorData(e)}>Click here to Download Vendor Data</Button>
                                        </div>
                                        :null}
                                        {this.state.loading?
                                        <div>
                                                <i className="fa fa-spinner"> </i>Fetching vendor Data....
                                        </div>
                                        :null}
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    </CardBody>              
                </Card>
            </Col>

        )
    }

}
const mapStateToProps = (state,ownProps) => ({

        vendorDataFile: state.vendorData.vendorDataFile,
        vendorDataError: state.vendorData.vendorDataError

})

const mapDispatchToProps = (dispatch,ownProps) => ({
    fetchVendorData: (data) => { dispatch(fetchVendorData(data)) }
})

export default withAuth(connect(
    mapStateToProps,
    mapDispatchToProps
)(VendorTrackerComponent));

